module.exports = __webpack_public_path__ + "media/newstyle/images/card-icon-4-16bb501e21d0c011af65bb93f1cebc17.svg";